// @flow
import { config } from '../../config'
import client from '../../client'
import type { Data } from './create'

// Constants
// eslint-disable-next-line
export const RESERVATION_ENDPOINT = '/reservations/send-link/';

/**
 * Send a booking link to a customer
 * @param {string} reservationData Reservation data
 * @return {Promise|Error} A resolved Promise or Rejected with an Error
 */
export const verify = (reservationData: Data): Promise<void> => {
  return client.post(RESERVATION_ENDPOINT, {
    body: reservationData,
    baseUrl: config.BASE_URL_RESERVATIONS,
  })
}

export default verify
